import ACTIONS from "../../constants/actions";

const initialState = {
	live : {
		events   : [],
		leagues  : [],
		sports   : [],
		fetching : true
	},
	line : {
		events   : [],
		leagues  : [],
		results  : [],
		sports   : [],
		fetching : true
	},
};

export default function result(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.RESULT.GET_LIVE: {
			const newState = {
				live : {...action.data, fetching : false},
			};
			return Object.assign({}, {...state, ...newState});
		}
		case ACTIONS.RESULT.GET_LINE: {
			const newState = {
				line : {...action.data, fetching : false},
			};
			return Object.assign({}, {...state, ...newState});
		}
		case ACTIONS.RESULT.FETCHING_LINE: {
			const newState = {
				line : {...state.line, fetching : true},
			};

			return Object.assign({}, {...state, ...newState});
		}
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/result.js